import RemoveFromTaskModal from "./RemoveFromTaskModal";

export default RemoveFromTaskModal;
